import React from 'react'
import emailjs from 'emailjs-com';

const EmailSender = () => {
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'YOUR_SERVICE_ID',
            'YOUR_TEMPLATE_ID',
            e.target,
            'YOUR_USER_ID'
        ).then(
            (result) => {
                console.log(result.text);
            },
            (error) => {
                console.log(error.text);
            }
        );
    };

    return (
        <div>
            <form onSubmit={sendEmail}>
                <input type="text" name="user_name" />
                <input type="email" name="user_email" />
                <textarea name="message" />
                <button type="submit">Send Email</button>
            </form>
        </div>
    )
}

export default EmailSender